import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const fetchById = (courseId: number): AxiosPromise<CourseStatusApi> => {
  return api.get<CourseStatusApi>(endpoints.COURSE_STATUS.GET_BY_ID(courseId));
};

export const courseStatusApi = {
  fetchById,
};

export interface CourseStatusApi {
  publicDataReady: boolean;
  sessionsReady: boolean;
  scheduleReady: boolean;
  tranchesReady: boolean;
  examsReady: boolean;
  resourcesReady: boolean;
  documentsReady: boolean;
  applicationFormReady: boolean;
  arePlacesPublic: boolean;
}
